import { ACTION_TYPES } from "../../../constants/index";

export const setOrganization = (items) => ({
  type: ACTION_TYPES.SET_ORGANIZATION,
  payload: items,
});

export const clearOrganization = () => ({
  type: ACTION_TYPES.CLEAR_ORGANIZATION,
});
